import React, { useEffect, useState } from "react";
import "./packagehome.css";

import Aos from "aos";
import "aos/dist/aos.css";
import Banner from "../Banner/Banner";

const PackageHome = () => {
  const [activeTab, setActiveTab] = useState("trip");
  const [tripType, setTripType] = useState("oneway");
  const [travelTime, setTravelTime] = useState("exact");

  useEffect(() => {
    Aos.init({ duration: 2000 });
  }, []);

  return (
    <section className="packagehome">
      {/* الخلفية */}
         <Banner page="packages" />

    </section>
  );
};

export default PackageHome;
